export const getCurrentLoggedInUserAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_CURRENT_LOGGEDIN_USER":
      return action.data;

    default:
      return state;
  }
};
